import { render } from "./SourceButton.vue?vue&type=template&id=773f24ca&scoped=true"
import script from "./SourceButton.vue?vue&type=script&lang=js"
export * from "./SourceButton.vue?vue&type=script&lang=js"

import "./SourceButton.vue?vue&type=style&index=0&id=773f24ca&lang=scss&scoped=true"
import "./SourceButton.vue?vue&type=style&index=1&id=773f24ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773f24ca"]])

export default __exports__